import React, { useEffect, useRef } from 'react';

export default function ChatAIScreen() {
  const token = localStorage.getItem('serviceToken');

  const dataforgeUrl = `https://dataforge-ai-1jb5.onrender.com?token=${token}`;
  console.log(dataforgeUrl);
  return (
    <div style={{ height: '700px', margin: -10, width: '100%' }}>
      <iframe
        id="dataforge-iframe"
        src={dataforgeUrl}
        title="Embedded Website"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        allowFullScreen
      />
    </div>
  );
}
